import { useMutation, UseMutationResult } from '@tanstack/react-query';

import { useCustomAlerts } from '@/shared/lib/alert';

import {
  createFeedback,
  ICreateFeedbackPayload
} from '@/entities/feedback/api/createFeedback';

/**
 * Создать мутацию отправки сообщения обратной связи.
 * Инвалидация кешей не нужна: своих сообщений пользователь не видит.
 */
export const useSendFeedbackMutation = (): UseMutationResult<
  unknown,
  Error,
  ICreateFeedbackPayload
> => {
  const { showCustomAlert } = useCustomAlerts();

  return useMutation({
    /**
     * Отправить сообщение обратной связи
     * @param payload - текст, метаданные и скриншот
     */
    mutationFn: (payload: ICreateFeedbackPayload) => createFeedback(payload),
    /**
     * Отображение ошибки
     * @param error - ошибка запроса
     */
    onError: error => {
      showCustomAlert(error.message, { severity: 'error' });
    },
    /**
     * Уведомление об успешной отправке
     */
    onSuccess: () => {
      showCustomAlert('Спасибо! Сообщение отправлено', { severity: 'success' });
    }
  });
};
